import template from './prems-discount-category-detail-discount.html.twig';

const { mapPropertyErrors } = Shopware.Component.getComponentHelper();

Shopware.Component.register('prems-discount-category-detail-discount', {
    template,

    props: {
        discountCategory: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
    },

    computed: {
        ...mapPropertyErrors('discountCategory', ['discount']),
        discountTypeOptions() {
            return [
                {
                    label: this.$tc('prems-discount-category.detail.card.discountValueAndType.field.discountType.relative'),
                    value: '0'
                },
                {
                    label: this.$tc('prems-discount-category.detail.card.discountValueAndType.field.discountType.absolute'),
                    value: '1'
                }
            ];
        },
        discountDisplayTypeOptions() {
            return [
                {
                    label: this.$tc('prems-discount-category.detail.card.displayDiscount.options.default'),
                    value: 0
                },
                {
                    label: this.$tc('prems-discount-category.detail.card.displayDiscount.options.discountInPercent'),
                    value: 1
                },
                {
                    label: this.$tc('prems-discount-category.detail.card.displayDiscount.options.strikePrice'),
                    value: 2
                }
            ];
        },
        discountOrUppriceOptions() {
            return [
                {
                    label: this.$tc('prems-discount-category.detail.card.discountValueAndType.field.discountOrUpprice.discount'),
                    value: false
                },
                {
                    label: this.$tc('prems-discount-category.detail.card.discountValueAndType.field.discountOrUpprice.upprice'),
                    value: true
                }
            ];
        },
        priceRoundingOptions() {
            return [
                {
                    label: this.$tc('prems-discount-category.detail.card.discountValueAndType.field.priceRounding.default'),
                    value: 0
                },
                {
                    label: this.$tc('prems-discount-category.detail.card.discountValueAndType.field.priceRounding.logically'),
                    value: 1
                },
                {
                    label: this.$tc('prems-discount-category.detail.card.discountValueAndType.field.priceRounding.up'),
                    value: 2
                },
                {
                    label: this.$tc('prems-discount-category.detail.card.discountValueAndType.field.priceRounding.down'),
                    value: 3
                },
            ];
        }
    },
});